import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import { Utils } from '../../Utils.js';
import { AppContext, ModalsContext, withAppContext } from '../../contexts/AppContext';
import Banner from "../../components/Banner/Banner.js";
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';

import HorisontalCategoryPicker from '../../components/HorisontalCategoryPicker/HorisontalCategoryPicker.js';
import ProductsSlider from '../../components/ProductsSlider/ProductsSlider.js';
import SublevelsCategoryPicker from '../../components/SublevelsCategoryPicker/SublevelsCategoryPicker.js';

import { Swiper, SwiperSlide  } from 'swiper/react';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import './Home.css'; 
import { t } from 'i18next';

class Home extends React.Component {

  state = {
    urlHash: 'home',
    data_to_render: {},
    loaded: 0
  }

  home_data = {};
  slideDirection = null;
  LOCALSTORAGE_KEY = 'home_data_cache';
  LOCALSTORAGE_VERSION_KEY = 'home_data_cache_version';
  CACHE_VERSION = process.env.REACT_APP_JS_VERSION;
  CACHE_EXPIRY = 1000 * 60 * 30; // 30 perc

  componentDidMount() {
    // Cache verzió ellenőrzés – elavult cache törlése
    const cachedVersion = Utils.localSorageGetWithExpiry(this.LOCALSTORAGE_VERSION_KEY);
    if (cachedVersion !== this.CACHE_VERSION) {
      Utils.localSorageSetWithExpiry(this.LOCALSTORAGE_VERSION_KEY, this.CACHE_VERSION, this.CACHE_EXPIRY);
      try { localStorage.removeItem(this.LOCALSTORAGE_KEY); } catch (e) {}
    }

    // Először localStorage-ból töltjük be az adatokat
    const cachedData = Utils.localSorageGetWithExpiry(this.LOCALSTORAGE_KEY);
    if (cachedData) {
      this.home_data = cachedData;
      this.setState({ loaded: 1 });
      this.setUrlHash();
    }

    // Aztán háttérben frissítjük a szerverről
    Utils.get_server_data('', { APICACHE: true }).then((resp) => {
      if (resp && resp.home_data) {
        this.home_data = resp.home_data || {};
        Utils.localSorageSetWithExpiry(this.LOCALSTORAGE_KEY, this.home_data, this.CACHE_EXPIRY);
        Utils.localSorageSetWithExpiry(this.LOCALSTORAGE_VERSION_KEY, this.CACHE_VERSION, this.CACHE_EXPIRY);

        // loaded és data_to_render egyszerre frissül – elkerüljük a közbülső üres rendert
        const hashValue = window.location.hash.replace(/^#/, '') || 'home';
        const newData = { ...this.home_data[hashValue] };
        this.setState({ loaded: 1, urlHash: hashValue, data_to_render: newData });
      }
    }).catch((error) => {
      console.error('Error loading home data:', error);
      if (this.state.loaded === 0) {
        this.setState({ loaded: 1 });
      }
    });

    window.addEventListener('hashchange', () => { this.setUrlHash(); }, false);
    window.addEventListener('categorySlideDirection', this.handleSlideDirection, false);

    if (this.containerRef.current) {
      this.containerRef.current.addEventListener('animationend', this.handleAnimationEnd);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('categorySlideDirection', this.handleSlideDirection, false);
    window.removeEventListener('hashchange', this.setUrlHash, false);
    
    if (this.containerRef.current) {
      this.containerRef.current.removeEventListener('animationend', this.handleAnimationEnd);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Csak akkor rendereljünk újra, ha az urlHash, data_to_render vagy loaded változott
    return (
      nextState.urlHash !== this.state.urlHash ||
      nextState.loaded !== this.state.loaded ||
      JSON.stringify(nextState.data_to_render) !== JSON.stringify(this.state.data_to_render)
    );
  }

  setUrlHash = () => {

    const hashValue = window.location.hash.replace(/^#/, '') || 'home';

    this.get_view_specific_data(hashValue);
  };

  /**
   * Azok az adatok amiket csak adott nézeteknél kell betölteni
   * 
   * @param {string} urlHash 
   * @returns 
   */
  get_view_specific_data = (urlHash = 'home') => {
    
    if (urlHash === 'home' || (this.home_data[urlHash]?.additional_data_loaded)) {
      this.setState({ urlHash, data_to_render: { ...this.home_data[urlHash] } });
      return Promise.resolve(true);
    }

    return Utils.get_server_data('', { APICACHE: true }, { ajax_event: 'get_home_view_additional_data', urlHash })
      .then((resp) => {
        this.home_data[urlHash] = {
          ...this.home_data[urlHash],
          newness: resp.home_view_additional_data?.newness || [],
          additional_data_loaded: true,
        };

        // Mentjük a frissített adatokat a cache-be
        Utils.localSorageSetWithExpiry(this.LOCALSTORAGE_KEY, this.home_data, this.CACHE_EXPIRY);

        // Csak akkor frissítjük a state-t, ha a felhasználó még mindig ezen a nézeten van
        const currentHash = window.location.hash.replace(/^#/, '') || 'home';
        if (currentHash === urlHash) {
          this.setState({ urlHash, data_to_render: { ...this.home_data[urlHash] } });
        }
        return true;
      });
  }

  handleSlideDirection = (e) => {
      this.slideDirection = e.detail;
  };

  handleAnimationEnd = () => {
      this.slideDirection = null;
      this.forceUpdate();
  };

  constructor(props) {
      super(props);
      this.appRef = this.props.appContext.appRef.current;
      this.containerRef = React.createRef();
  }

  render() {

    const { data_to_render, urlHash } = this.state;
    const slideClass = this.slideDirection ? ' slide-' + this.slideDirection : '';

    return (
      <div ref={this.containerRef} className={`container page_home${slideClass}`}>
        {urlHash === 'home' ? this.render_home(data_to_render) : this.render_category(data_to_render,urlHash)}
      </div>
    );
    
  }
  
  render_category(data_to_render,urlHash){

    const category_data = this.appRef.state.categories?.categories?.[data_to_render?.id] || null;
    
    return (
      <div className="content">
        {this.show_hero_slider(data_to_render)}
        <SublevelsCategoryPicker category={category_data} parent_category_url={urlHash}  />
        {this.create_full_product_banners(1,data_to_render)}
        {(data_to_render.banners?.[102]?.[0]) ? this.show_full_banner(data_to_render.banners[102][0]) : ''}
        {this.create_full_product_banners(2,data_to_render)}
        {(data_to_render.banners?.[102]?.[1]) ? this.show_full_banner(data_to_render.banners[102][1]) : ''}
        {(data_to_render.highlighted_products) ? this.render_highlighted_products_section(data_to_render,'highlighted_products') : ''}
      </div>      
    );
  }


  render_home(data_to_render) {

    const MaxBanners = [0,1,2,3,4,5,6,7,8,9]
    const FullWidthBanners = data_to_render?.banners && data_to_render.banners[102] ? data_to_render.banners[102] : [];

    return (
      <div className="content">
        {this.show_hero_slider(data_to_render)}
        <HorisontalCategoryPicker key="home" flag="home" showImages={true}  />
        {MaxBanners.map((banner_index) =>
          this.home_create_banner_and_products(banner_index, data_to_render, FullWidthBanners)
        )}
        {this.render_highlighted_products_section(data_to_render)}
      </div>
    );

  }

  home_create_banner_and_products(banner_index, data_to_render, FullWidthBanners) {
    return (
      <React.Fragment key={banner_index}>
        {this.create_category_boxes(data_to_render, banner_index)}
        {this.create_full_product_banners(banner_index,data_to_render)}
        {(FullWidthBanners.length > 0 && FullWidthBanners[banner_index]) ? this.show_full_banner(FullWidthBanners[banner_index]) : ''}
      </React.Fragment>
    );
  }

  create_full_product_banners(banner_index,data_to_render) {

    const settings = {
      1: {index: 'newness', label: t('newnessSliderLabel')},
      2: {index: 'top_products', label: t('topProductsSliderLabel')},
    };

    if (!settings[banner_index]) return '';

    const current_setting = settings[banner_index];

    const Products = data_to_render?.[current_setting.index] || [];
    const BgColor = data_to_render?.settings?.background_colors?.[current_setting.index] || '';

    if (Products?.products?.length === 0) return '';

    return <div className='home_products_slider_cont right_sticky' key={banner_index}>
      <ProductsSlider
        boxTitle={current_setting.label || ''}
        products={Products.products || []}
        backgroundColor={BgColor}
        productBoxType={'default'}
        slideItemCount={1}
        showFavIcon={true}
        showDots={false}
      >
      </ProductsSlider>
    </div>

  }

  create_category_boxes(data_to_render, banner_index) {

    if (!data_to_render?.categories) return '';

    return Object.keys(data_to_render.categories).map((category_key, index) =>
      this.map_category_boxes(category_key, index, data_to_render, banner_index)
    );
  }

  map_category_boxes(category_key, index, data_to_render, banner_index) {
    
    if (banner_index !== index) return '';
    if (!data_to_render.categories[category_key].top_products) return '';
    
    return this.render_category_box_products_slider(data_to_render, category_key);
  }

  
  show_hero_slider(data_to_render) {
    return (
      <div className='hero-slider'>
        {data_to_render?.banners && data_to_render.banners[101] ? 
            <Swiper 
              className='home_hero_slide'
              autoplay={{
                delay: 7000,
                disableOnInteraction: true,
              }}
              pagination={{
                clickable: true,
              }}
              //navigation={true}
              modules={[Autoplay, Pagination, Navigation]}>
                {data_to_render.banners[101].map((banner,index)=>{
                  return <SwiperSlide key={banner.id}>
                    <Banner type={(banner.app_banner_type_txt) ? banner.app_banner_type_txt : ''} text={banner.alt} url={banner.link} image={banner.banner} />
                  </SwiperSlide>
                })}
            </Swiper>
          : ''}
      </div>      
    );
  }

  render_category_box_products_slider(category_data,index) {

    const Products = category_data.categories[index]?.top_products || [];
    const BgColor = category_data?.settings?.background_colors[index] || '';
    const CategoryLabel = category_data?.categories[index]?.label ? category_data.categories[index].label : null;

    return this.render_product_slider(Products,CategoryLabel,BgColor,'smallProductBox',8,true);
    
  }

  render_product_slider(products,boxTitle,BgColor,productBoxType='default',slideItemCount=1,showDots=false) {
    return <div className='home_products_slider_cont' key={boxTitle}>
      <ProductsSlider
        boxTitle={boxTitle || ''}
        products={products}
        backgroundColor={BgColor}
        productBoxType={productBoxType}
        slideItemCount={slideItemCount}
        showDots={showDots}
      >
      </ProductsSlider>
    </div>;
  }

  show_full_banner(banner_data) {

    return (
      <div className='full-width-banner'>
        <Banner type={(banner_data.app_banner_type_txt) ? banner_data.app_banner_type_txt : ''} text={banner_data.alt} url={banner_data.link} image={banner_data.banner} />
      </div>      
    );

  }

  render_highlighted_products_section(data,index='categories') {

    const BgColor = data?.settings?.background_colors?.highlighted || '#F5F5F5';
    const render_data = data[index];

    if(!render_data){
      return null;
    }

    const HighlightedProductsSliderData = {};
    let hasHighlightedProducts = false;

    Object.keys(render_data).forEach((category_key) => {
      const category = render_data[category_key];
      if (category.highlighted_products && category.highlighted_products.length > 0) {
        hasHighlightedProducts = true;
        HighlightedProductsSliderData[category_key] = {
          label: category.label || '',
          products: category.highlighted_products,
          tabIndex: category_key
        };  
      }
    });
    
    if (!hasHighlightedProducts) {
      return null;
    }

    return (<div className='home_products_slider_cont'>
      <ProductsSlider
        boxTitle={t('HomeHighlightedBoxTitle') || ''}
        products={HighlightedProductsSliderData || []}
        backgroundColor={BgColor}
        productBoxType={'tabProductBox'}
        showProductRating={true}
        showFavIcon={true}
        showDots={false}
      >
      </ProductsSlider>
    </div>);
  }

}


/**
 
 */

export default withAppContext(Home);